import { Component, OnInit,ViewChild } from '@angular/core';
import { IonContent  } from "@ionic/angular";
import { RequestParams } from '../../../../common/rest-api/models/request-params';//'src/core/shared/rest-api/models/request-params';
import { EmployeeTransferService } from '../../services/employee-transfer.service';
import { EmployeeTransfer } from '../../models/employee-transfer.model';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { Router } from '@angular/router';
import { ToasterService } from '../../../../common/services/toaster.service';

@Component({
  selector: 'app-employee-transfer-page',
  templateUrl: 'employee-transfer.page.html',
  styleUrls: [
    './employee-transfer.page.scss',
  ]
})
export class EmployeeTransferPage implements OnInit{
@ViewChild(IonContent) content!: IonContent;
  customer: string;
  deptNo: string;
  startDate: Date;
  endDate: Date;
  transferType: string;

  rows: any;
  requestParams: any;

  currentPage: number;
  pageSize: number;

  totalElements: number;
  totalPages: number;
  pageNumbers = [];
  loaded:boolean;
  transfers: EmployeeTransfer[]; 

  searchProcessed: boolean = false;

  constructor(
    private employeeTransferService: EmployeeTransferService,
    public authService: GtrakAuthService,
    private toasterService: ToasterService,
    private router: Router,
        
  ) { 

  }

  selectDepartmentStatus(ev) {
    
    this.transferType = ev.detail.value;
  }

  ngOnInit(): void {
    this.loaded=false;
    if(!this.authService.user.canViewEmployeeTransfer) {
      this.router.navigate([this.authService.user.homeLocation]);
    }

    if(this.authService.user.isCustomerUser) {
      this.customer = this.authService.user.customerCode;
    }
 
    this.customer = this.authService.user.customerCode;

    this.setDefaults();

    this.currentPage = 1;
      if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.pageSize = 500;
   }
    this.requestParams = new RequestParams();
    this.loaded=true;
  }
 ionViewWillEnter(): void {
      if( localStorage.getItem("pageSize")!=null){
        this.pageSize=Number(localStorage.getItem("pageSize"));
   }
   else{
    this.pageSize = 500;
   }
   if(this.rows!=undefined){
    this.rows = [...this.rows]; 
   }
  }

  setDefaults(): void {
        const today = new Date(); 
        const start = new Date();
        start.setDate(today.getDate() - 30); 

        this.startDate = start.toISOString().substring(0, 10) as any;
        this.endDate = today.toISOString().substring(0, 10) as any;
        this.transferType = "1";
  }

  async getTransferData(): Promise<void> {
    if (this.authService.user.customerCode?.length > 0 && this.customer !== this.authService.user.customerCode) {
      this.toasterService.presentToast('danger', '', 'Invalid Customer Code', 1600);
      this.customer = this.authService.user.customerCode;
      return;
    }

    this.requestParams.setPaging(this.currentPage, this.pageSize);
    
    var transfers = await this.employeeTransferService.findTransferReports(this.requestParams);

    this.transfers = transfers.results;

    this.totalElements = transfers.totalRecords;
    this.totalPages = transfers.totalPages;

    this.rows = transfers.results;

    //remove filters
    delete this.requestParams.filters.newCustCode;
    delete this.requestParams.filters.newDeptCode;
    delete this.requestParams.filters.preCustCode;
    delete this.requestParams.filters.preDeptCode;
    delete this.requestParams.filters.dateRange;

    this.pageNumbers = Array(this.totalPages).fill(1).map((x, i) => i)
    this.pageNumbers.push(this.totalPages);
    this.searchProcessed = true;
    this.loaded=true;
  }

async setPage(event: { pageNumber: number, pageSize:number ;sortField?: string, sortDirection?: string }): Promise<void> {
        this.loaded = false;
        
        this.pageSize=event.pageSize;
        this.currentPage = event.pageNumber;
        if(event.sortField==""){
           this.requestParams.setOrdering('lastName', 'asc');
        }else{
        this.requestParams.setOrdering(event.sortField, event.sortDirection);
        }
        await this.getTransfers();
         this.content.scrollToTop(500);
        this.loaded = true;
        }
  async getTransfers(): Promise<void> {
    this.loaded=false;
    this.currentPage = 1;
    //check if customer number is entered
    if(!this.customer && this.customer != '') {
      this.toasterService.presentToast('warning', '' , 'Please enter a customer number', 3000);
      return;
    }
    //check if end date and start date are entered
    if(!this.startDate && !this.endDate) {
      this.toasterService.presentToast('warning', '' , 'Please enter a start date and end date', 3000);
      return;
    }
    //check if department number is entered
    // if(!this.deptNo && this.deptNo != '') {
    //   this.toasterService.presentToast('warning', '' , 'Please enter a department number', 3000);
    //   return;
    // }
    //check if transfer type is selected
    if(!this.transferType && this.transferType != '') {
      this.toasterService.presentToast('warning', '' , 'Please select a transfer type', 3000);
      return;
    }
    // type 1 = into department
    // type 2 = out of department
    
    if(this.transferType == '1') {
      if(this.customer!=null && this.customer!=undefined && this.customer!=""){
      this.requestParams.filters.newCustCode = this.customer;
      }
      if(this.deptNo && this.deptNo != '') {
        this.requestParams.filters.newDeptCode = this.deptNo;
      }
    } else {
      this.requestParams.filters.preCustCode = this.customer;
      if(this.deptNo && this.deptNo != '') {
        this.requestParams.filters.preDeptCode = this.deptNo;
      }
    }

    this.requestParams.filters.dateRange = this.startDate.toString() + ',' +  this.endDate.toString()

    await this.getTransferData();
     this.loaded=true;
    
  }

  selectPage(number: number): void {
    if(number <= 0) return;

    this.currentPage = number;

    this.requestParams.setPaging(this.currentPage, this.pageSize);

    this.getTransferData();
  }
  onEnterKey(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getTransfers();
    }
}